import GraphContainer from './GraphContainer';

export default GraphContainer;
